import { render, staticRenderFns } from "./MiniBarPaymentOrder.vue?vue&type=template&id=01bd9808&scoped=true&"
import script from "./MiniBarPaymentOrder.vue?vue&type=script&lang=js&"
export * from "./MiniBarPaymentOrder.vue?vue&type=script&lang=js&"
import style0 from "./MiniBarPaymentOrder.vue?vue&type=style&index=0&id=01bd9808&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bd9808",
  null
  
)

export default component.exports